import { Card, Skeleton, SkeletonButton, SkeletonRegion } from '@parsina/framework';
import { C } from '@parsina/framework/tokens';
import { STACK } from '../../constants/density';
import { useTranslation } from '../../i18n';

/**
 * The invitation landing while the clinic behind the code is being fetched.
 *
 * Rendered INSIDE the same `AuthShell` the real page uses, so the shell — logo,
 * title, subtitle — paints once and stays put; only the card, the notice and
 * the two buttons are blocks. The card is the one the clinic will occupy: a
 * name line, three fact lines (type, place, phone), then the approval notice
 * and the submit/cancel pair at their real sizes, so nothing moves when the
 * clinic lands (DESIGN.md §"Loading & skeleton").
 */
export default function InviteSkeleton() {
  const { t } = useTranslation();
  return (
    <SkeletonRegion
      label={t('common.state.loading')}
      data-testid="invite-skeleton">
      <Card style={{ padding: 18, background: C.bg }}>
        <Skeleton width="55%" height={18} style={{ marginBottom: 12 }} />
        {[0, 1, 2].map((i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: i ? 8 : 0 }}>
            <Skeleton width={16} height={16} radius={4} />
            <Skeleton width={`${34 + (i * 19) % 40}%`} height={13} />
          </div>
        ))}
      </Card>

      <Skeleton width="100%" height={52} radius={12} style={{ marginTop: STACK.regular }} />

      <div style={{ display: 'flex', gap: 10, marginTop: 20, flexWrap: 'wrap' }}>
        <SkeletonButton style={{ flex: 1, minWidth: 180, width: 'auto' }} />
        <SkeletonButton width={96} />
      </div>
    </SkeletonRegion>
  );
}
